import { createContext } from "react";
var configurationKeys = [
    "auth0ClientId",
    "auth0IssuerDomain",
    "auth0Redirect",
    "hasuraUrl",
    "redirect",
    "region",
    "signout",
    "userPoolClientId",
    "userPoolDomain",
    "userPoolId",
    "userPoolIssuer",
    "learningCenterUrl",
];
var optionalConfigurationKeys = [
    "googlePlacesAPIKey",
    "enableHotjar",
    "sentryDSN",
    "sentryEnv",
    "sentryEnabled",
    "sentryRelease",
];
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export var isConfiguration = function (o) {
    return configurationKeys.reduce(function (previous, current) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return previous && current in o && typeof o[current] == "string";
    }, true);
};
export var ConfigContext = createContext(null);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uZmlnLmpzeCIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImNvbmZpZy50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLGFBQWEsRUFBRSxNQUFNLE9BQU8sQ0FBQztBQUV0QyxJQUFNLGlCQUFpQixHQUFHO0lBQ3hCLGVBQWU7SUFDZixtQkFBbUI7SUFDbkIsZUFBZTtJQUNmLFdBQVc7SUFDWCxVQUFVO0lBQ1YsUUFBUTtJQUNSLFNBQVM7SUFDVCxrQkFBa0I7SUFDbEIsZ0JBQWdCO0lBQ2hCLFlBQVk7SUFDWixnQkFBZ0I7SUFDaEIsbUJBQW1CO0NBQ1gsQ0FBQztBQUVYLElBQU0seUJBQXlCLEdBQUc7SUFDaEMsb0JBQW9CO0lBQ3BCLGNBQWM7SUFDZCxXQUFXO0lBQ1gsV0FBVztJQUNYLGVBQWU7SUFDZixlQUFlO0NBQ1AsQ0FBQztBQVFYLDhEQUE4RDtBQUM5RCxNQUFNLENBQUMsSUFBTSxlQUFlLEdBQUcsVUFBQyxDQUFNO0lBQ3BDLE9BQU8saUJBQWlCLENBQUMsTUFBTSxDQUFVLFVBQUMsUUFBUSxFQUFFLE9BQU87UUFDekQsc0VBQXNFO1FBQ3RFLE9BQU8sUUFBUSxJQUFJLE9BQU8sSUFBSSxDQUFDLElBQUksT0FBTyxDQUFDLENBQUMsT0FBTyxDQUFDLElBQUksUUFBUSxDQUFDO0lBQ25FLENBQUMsRUFBRSxJQUFJLENBQUMsQ0FBQztBQUNYLENBQUMsQ0FBQztBQUVGLE1BQU0sQ0FBQyxJQUFNLGFBQWEsR0FBRyxhQUFhLENBQWdCLElBQUksQ0FBQyxDQUFDIn0=